// extracted by mini-css-extract-plugin
export default {"root":"ui-icon_root__pRlsA"};